<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-dialog filter-dialog" :title="$t('Filter')" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar ref="vueScrollBar" :settings="settings" class="scroll-area--data-list p-6">
			<request-filter :requestTypes="requestTypes" :value="localSimpleFilterData" :isDisabledFilterType="isDisabledSimpleFilterType" @onFilter="handleChangeSimpleFilter" />

			<div class="inline-block">
				<vs-checkbox v-model="isShowAdvancedFilter" :disabled="!localSimpleFilterData.type" :class="['ml-0 mt-6', { 'opacity-50': !localSimpleFilterData.type }]">{{
					$t("AdvancedFilter")
				}}</vs-checkbox>
			</div>

			<transition name="el-zoom-in-top">
				<request-advanced-filter class="mt-3" v-if="isShowAdvancedFilter" :value="localAdvancedFilterData" :key="localSimpleFilterData.type.id" @onFilter="handleChangeAdvancedFilter" />
			</transition>
		</PerfectScrollbar>

		<div slot="footer" class="flex items-center justify-center">
			<cbs-download-button
				class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold"
				v-if="value && value.simpleFilter && value.simpleFilter.type"
				:btnText="$t('Actions.Statistical')"
				@click.stop="$emit('onClickExport')"
			/>

			<vs-button type="border" :disabled="!isHasFilter" @click.stop="handleResetLocalFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Reset") }}</vs-button>

			<vs-button @click.stop="onApplyFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Apply") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import RequestFilter from "./RequestFilter";
import RequestAdvancedFilter from "./RequestAdvancedFilter";

const defaultLocalSimpleFilterData = {
	type: null,
	status: null,
	creator: null,
	createdDate: []
};

export default {
	name: "RequestFilterDialog",
	inheritAttrs: false,
	components: {
		RequestFilter,
		RequestAdvancedFilter
	},
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		},
		value: {
			type: Object,
			required: true,
			validator: prop => {
				const simpleFilter = _.get(prop, "simpleFilter");
				const advancedFilter = _.get(prop, "advancedFilter");
				if (!simpleFilter || !advancedFilter) {
					return false;
				}

				return _.has(simpleFilter, "type") && _.has(simpleFilter, "status") && _.has(simpleFilter, "creator") && _.has(simpleFilter, "createdDate");
			}
		},
		requestTypes: Array,
		isDisabledSimpleFilterType: Boolean
	},
	emits: {
		onApplyFilter: {}
	},
	data() {
		return {
			isShowAdvancedFilter: false,
			localAdvancedFilterData: [],
			localSimpleFilterData: defaultLocalSimpleFilterData,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		isHasFilter() {
			const objectToCompare = this.isDisabledSimpleFilterType ? _.omitBy(this.localSimpleFilterData, (item, key) => key === "type") : this.localSimpleFilterData;
			return _.some(objectToCompare, prop => !_.isEmpty(prop) || prop === 0);
		}
	},
	watch: {
		isDialogActiveLocal() {
			if (this.isDialogActiveLocal) {
				this.initFilterData();
			}
		},
		localSimpleFilterData(newVal, oldVal) {
			const newSelectedType = _.get(newVal, "type") || {};
			const oldSelectedType = _.get(oldVal, "type") || {};
			const valueSelectedType = _.get(this.value, "simpleFilter.type") || {};

			if (!_.isEqual(newSelectedType, oldSelectedType) && !_.isEqual(valueSelectedType, newSelectedType)) {
				this.localAdvancedFilterData = this.formatFormFieldData(_.get(this.localSimpleFilterData, "type.controls") || []);
			}

			if (_.isEmpty(newSelectedType)) {
				this.isShowAdvancedFilter = false;
			}
		},
		isShowAdvancedFilter() {
			if (!this.isShowAdvancedFilter) {
				if (this.$refs.vueScrollBar) {
					this.$nextTick(() => {
						this.$refs.vueScrollBar.$el.scrollTop = 0;
					});
				}
			}
		}
	},
	methods: {
		handleChangeSimpleFilter(filter) {
			this.localSimpleFilterData = filter;
		},
		onApplyFilter() {
			this.$emit("onApplyFilter", {
				simpleFilter: this.localSimpleFilterData,
				advancedFilter: this.localAdvancedFilterData
			});
		},
		initFilterData() {
			this.localSimpleFilterData = this.value.simpleFilter;
			this.localAdvancedFilterData = this.value.advancedFilter;
		},
		handleResetLocalFilter() {
			this.isShowAdvancedFilter = false;
			this.localSimpleFilterData = !this.isDisabledSimpleFilterType ? defaultLocalSimpleFilterData : { ...defaultLocalSimpleFilterData, type: this.localSimpleFilterData.type };
		},
		handleChangeAdvancedFilter(filter) {
			this.localAdvancedFilterData = filter;
		},
		formatFormFieldData(fields) {
			const cloneFields = _.cloneDeep(fields);
			const mappedData = [];
			cloneFields.forEach(field => {
				if (field.control === this.$constant.request.control.text || field.control === this.$constant.request.control.textarea) {
					field.value = "";
				} else if (field.control === this.$constant.request.control.datetime) {
					field.value = [null, null];
				} else {
					field.value = [];
				}
				if (field.control !== this.$constant.request.control.attach) {
					mappedData.push(field);
				}
			});

			return mappedData;
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-dialog.filter-dialog {
	::v-deep .el-dialog {
		margin-right: 0 !important;
	}
}

.request-filter {
	.request-filter__item {
		&:not(:last-child) {
			margin-right: 15px;
		}

		::v-deep .vs__dropdown-menu {
			top: initial;
		}
	}
}

.dialog-fade-enter-active {
	animation: dialog-fade-in 0.2s ease-in-out;
}

.dialog-fade-leave-active {
	animation: dialog-fade-out 0.5s ease-in-out;
}

@keyframes dialog-fade-in {
	0% {
		opacity: 0;
		transform: translateX(100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes dialog-fade-out {
	0% {
		opacity: 1;
		transform: translateX(0);
	}
	100% {
		opacity: 0;
		transform: translateX(100%);
	}
}
</style>
